export default "__VITE_ASSET__CAJIDoC$__"